import { IGetGestaoRecebimentoEpiByIdUseCase } from "../../../presentation/useCases/read/get_gestao_recebimento_epi_by_id_use_case";
import { GestaoRecebimentoEpi } from "../../models/gestao_recebimento_epi";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

/**
 * GetGestaoRecebimentoEpiByIdUseCase
 */

export class GetGestaoRecebimentoEpiByIdUseCase implements IGetGestaoRecebimentoEpiByIdUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async getGestaoRecebimentoEpiById(
    idGestaoRecebimentoEpi: number,
  ): Promise<GestaoRecebimentoEpi> {
    const result = await this.repository.getGestaoRecebimentoEpiById(idGestaoRecebimentoEpi);
    if (result === null) throw new Error('Falha ao buscar recebimento de epi!');
    return result;
  }
}
